<template>
    <Modal
        :title="$t('labels.product_item')"
        size="md"
        ref="Modal"
    >
        <div class="modal-body">
            <Fieldset :title="$t('labels.basic_information')">
                <FormGroup :label="$t('labels.product_types')">
                    <div v-for="category in categories" :key="category.id">
                        <InputGroup>
                            <template #prepend>
                                <AppCheckbox
                                    :modelValue="selectedIds.includes(category.id)"
                                    @update:modelValue="toggleCategory(category.id)"
                                />
                            </template>
                            <span class="form-control border-0">{{ category.name }}</span>
                        </InputGroup>
                    </div>
                </FormGroup>
            </Fieldset>
        </div>
        <div class="modal-footer">
            <Button size="sm"
                @click="create"
                color="teal"
            >
                {{ $t('buttons.create') }}
            </Button>
        </div>
    </Modal>
</template>

<script>
import Modal from '../../../../../components/new/modal/AppModal.vue'
import Fieldset from '../../../../../components/new/AppFieldset.vue'
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue'
import InputGroup from '../../../../../components/new/form/InputGroup.vue'
import AppCheckbox from '../../../../../components/new/form/checkbox/AppCheckbox.vue'
import Button from '../../../../../components/new/button/AppButton.vue'
import { httpClient } from '../../../../../services/HttpClient.ts'
import MessageNotificator from '../../../../../services/MessageNotificator'

export default {
    name: 'CreateProductItemsFromCategoryModal',
    components: {
        Modal,
        Fieldset,
        FormGroup,
        InputGroup,
        AppCheckbox,
        Button
    },
    props: {
        inventoryUuid: {
            type: String,
            required: true
        }
    },
    emits: ['updateTable'],
    data() {
        return {
            categories: [],
            selectedIds: []
        }
    },
    methods: {
        show() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/pim/types`).then((response) => {
                this.categories = response.data.data
            })
            this.$refs.Modal.show()
        },
        hide() {
            this.categories = []
            this.selectedIds = []
            this.$refs.Modal.hide()
        },
        toggleCategory(id) {
            const index = this.selectedIds.indexOf(id)
            if (index === -1) {
                this.selectedIds.push(id)
            } else {
                this.selectedIds.splice(index, 1)
            }
        },
        create() {
            httpClient.post(`/management/inventories/${this.inventoryUuid}/inventory-product-items/store-by-categories`, {
                category_ids: this.selectedIds
            }).then(() => {
                new MessageNotificator().success(`${this.$t('alerts.created', {
                    model: this.$t('labels.product_item')
                })}`)
                this.$emit('updateTable')
                this.hide()
            })
        }
    }
}
</script>
